import { fsGetDoc } from '@monash/portal-frontend-common';
import { useEffect, useMemo, useState } from 'react';
import { GLOBAL_BANNERS } from './constants';
import { isValid } from 'date-fns';

export const useGlobalBannersData = ({ userIs }) => {
  const [bannerConfig, setBannerConfig] = useState();
  const [error, setError] = useState(false);

  const fetchBannerConfig = async () => {
    try {
      const bannerConfigDoc = await fsGetDoc('config/banners');
      setBannerConfig(bannerConfigDoc.data());
    } catch (error) {
      console.error('Error retrieving banner config');
      setError(true);
    }
  };

  useEffect(() => {
    fetchBannerConfig();
  }, []);

  const globalBannersData = useMemo(() => {
    const { configs } = bannerConfig ?? {};

    if (error || !Array.isArray(configs) || !userIs) return [];

    return configs
      .reduce((acc, currentBanner) => {
        const bannerId = currentBanner.id;

        // validate that data exists
        if (!(bannerId in GLOBAL_BANNERS)) {
          console.warn(`Banner id (${bannerId}) not found`);
          return acc;
        }

        const bannerDataHardcoded = GLOBAL_BANNERS[bannerId];
        const { startDate, endDate, isNew } = currentBanner;
        const parsedStartDate = startDate?.toDate?.();
        const parsedEndDate = endDate?.toDate?.();

        // validate start/end dates
        if (!isValid(parsedStartDate) || !isValid(parsedEndDate)) {
          console.warn(`Invalid start/end date for banner: ${bannerId}`);
          return acc;
        }

        const enrichedBannerData = {
          ...bannerDataHardcoded,
          startDate: parsedStartDate,
          endDate: parsedEndDate,
          isNew,
        };

        return [...acc, enrichedBannerData];
      }, [])
      .sort((a, b) => {
        if (a.endDate > b.endDate) {
          return -1;
        } else if (a.endDate < b.endDate) {
          return 1;
        }
        return 0;
      });
  }, [bannerConfig, error, userIs]);

  return {
    globalBannersData,
  };
};

export const isBannerRelevantToUser = ({ userIs, bannerCohorts = null }) => {
  // relevant cohorts omitted means the banner is relevant for all cohorts
  if (!bannerCohorts) return true;

  for (const cohort of bannerCohorts) {
    if (userIs[cohort]) return true;
  }

  return false;
};
